// extracted by mini-css-extract-plugin
export default {"wrap":"InstallPrompt_wrap__Xv50e","button":"InstallPrompt_button__d6M5r","hint":"InstallPrompt_hint__4rchw"};